export const VERSION = '5.0.0-alpha.0';
export const ID = '6dcc0b4f5c5721145012cc5ed2456e85cf1d03b7';
export const DATE = '2023-07-11T08:48:34.344Z';
